import styled from 'styled-components';
import { Column } from '../../components/base/grid';
import media from '../../constants/media';

export const CtaWrapper = styled.div`
	margin-bottom: 6rem;
	margin-left: 20%;
	margin-right: -20%;
`;

export const StyledColumn = styled(Column)`
	display: none;
	${media.desktopSmall`
		display: block;
	`}
`;
